import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

import './redirect';
import './iframe';
import './disableDownloadButtons';
import './hideAlertInfo';
import './linkRememberLocation';

onElelementExistRunOnce('.best_in_place', () => {
  void import('./internal/best_in_place').then(({ default: Component }) => Component());
});
